import { render, staticRenderFns } from "./Template9.vue?vue&type=template&id=40025601&scoped=true&"
import script from "./Template9.vue?vue&type=script&lang=js&"
export * from "./Template9.vue?vue&type=script&lang=js&"
import style0 from "./Template9.vue?vue&type=style&index=0&id=40025601&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40025601",
  null
  
)

export default component.exports